import { call, select } from "redux-saga/effects";

import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";
import { AnyEntity } from "@mapmycustomers/shared/types/entity";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import RecordsPastDueCardData from "@app/scene/dashboard/store/cards/recordsPastDue/RecordsPastDueCardData";
import { callApi } from "@app/store/api/callApi";
import { getOrganizationId } from "@app/store/iam";
import RecordsPastDueCardConfiguration from "@app/types/dashboard/cards/recordsPastDue/RecordsPastDueCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

import { fetchMethodByEntityType } from "./common";

export function* fetchRecordsPastDueCardDataHelper(params: {
  callback: (data: RecordsPastDueCardData) => void;
  configuration: RecordsPastDueCardConfiguration;
  scope?: Scope;
}) {
  const { callback, configuration, scope } = params;
  const { criteria, extraFilters } = configuration;
  const isTeamScope = !!scope?.teamId && !scope?.userId;

  const orgId: Organization["id"] = yield select(getOrganizationId);

  const fetchMethod = fetchMethodByEntityType[criteria.entityType];

  const filters = {
    ...extraFilters,
    cadenceDaysOut: { $gt: 0 },
    source: criteria.sources.length ? { $in: criteria.sources } : undefined,
    teamId: isTeamScope ? { [PlatformFilterOperator.CONTAINS]: [scope.teamId!] } : undefined,
    userId: scope?.userId ? { [PlatformFilterOperator.CONTAINS]: [scope.userId] } : undefined,
  };

  const payload = { $filters: filters, $limit: 0 };

  const response: ListResponse<AnyEntity> = yield callApi(fetchMethod, orgId, payload);

  const result: RecordsPastDueCardData = { count: response.total };

  yield call(callback, result);
}
